module.exports=function(){
    $(".menu span").click(function(){
        var index=$(this).index();
        $(".menu span").removeClass("icon-menu_current");
        $(this).addClass("icon-menu_current");
        $(".gxzb_list").hide().eq(index).show();
    })
}